//currency-switcher
$(document).ready(function(){
  $("body").delegate("span.product_sort", "click", function(e){
    e.preventDefault();
  $("#sortModalBar").modal("show");
  });
    $("body").delegate("span.product_filter", "click", function(e){
    e.preventDefault();
  $("#filterModalBar_c").modal("show");
  });
  $("body").delegate("label.radio-button.button-radio", "click", function(e){
      var getval=$(this).find('input').val();
    var urll = $(this).find('input').attr('datahref');
  $(".Selected_filter_sort.filter_footer button.withouthover.btn-standared").attr('datahref',urll)
  //console.log(urll);
    // filtersort(urll);
  });
  $("body").delegate(".Selected_filter_sort.filter_footer button.withouthover.btn-standared", "click", function(e){
  var urll = $(this).attr('datahref');
            window.location.href = urll;
  //  filtersort(urll);
  //  $("#sortModalBar").modal("hide");
    });
  $("body").delegate("label.checkbox.control-checkbox", "click", function(e){ 
  
  
  
      if ($(this).find('input[type="checkbox"]').is(':checked')){
      var name= jQuery(this).find('input[type="checkbox"]:checked').attr('value');
      var datahandle =jQuery(this).find('input[type="checkbox"]:checked').attr('datahandle');
      console.log(name+','+datahandle);
      var ss="product_type";
      seleteditem_filter(name,datahandle,ss);
      }
      else{
      console.log('remove');
      var name= jQuery(this).find('input[type="checkbox"]').attr('value');
      var datahandle =jQuery(this).find('input[type="checkbox"]').attr('datahandle');
      removedditem_filter(name,datahandle);
      }
  })
  
  
    function filtercolour_tag(){
        var values = [];  
      var d_filters = []; 
        jQuery('.selected-items ul li[datasel="product_colour"]').each(function(){
          var value= jQuery(this).attr('deleteitem');
          console.log('neeta '+value);
          var df_val = jQuery(this).data('filter');
          if(values.indexOf(value) === -1) {
            if(value){
              values.push(value);
             // console.log('Go');
            }
          }     
        });
  
         jQuery('.selected-items ul li[datasel="product_type"]').each(function(){
          var p_type= jQuery(this).attr('deleteitem');
          console.log('neeta '+p_type);
          var df_val = jQuery(this).data('filter');
          if(d_filters.indexOf(p_type) === -1) {
            if(p_type){
              d_filters.push(p_type);
             // console.log('Go');
            }
          }     
        });
  
  
     if (typeof coll_value === "undefined") {
          var pathname = window.location.pathname; 
          var data=pathname.split("/");
          var collection=data[2];  
          var coll_value = collection;
          //console.log(url);
  
        }
  //console.log("neeta-1"+coll_value);
  
        ajaxFilter(values, d_filters, coll_value);
    }
    
  
      function ajaxFilter(items, groups, coll_value){
        var array_values = '';
        var product_type = '';
        for( i=0; i<= items.length; i++){
          //console.log('items ' +items);
          //console.log('leangth '+items.length);
          if(items[i] != undefined){  
            if(items.length == 1){
              array_values += items[i]; 
             // console.log('if '+array_values);
              //return false;
            }
            else if(items.length > 1){
              if((i + 1) == (items.length)){
                array_values += items[i] ;
                //console.log('elseif '+array_values);
              }
              else{
                array_values += items[i] + '+' ; 
                //console.log('else '+array_values);
              }
            }
          }
        }
  
  for( i=0; i<= groups.length; i++){
          //console.log('items ' +items);
          //console.log('leangth '+items.length);
          if(groups[i] != undefined){  
            if(groups.length == 1){
              product_type += groups[i]; 
             // console.log('if '+array_values);
              //return false;
            }
            else if(groups.length > 1){
              if((i + 1) == (groups.length)){
                product_type += groups[i] ;
                //console.log('elseif '+array_values);
              }
              else{
                product_type += groups[i] + '+' ; 
              }
            }
          }
        }
        
  var size = $('.featured-products-slider .radio input:checked').val();
  if(size){
        array_values += '&size=size-' + size;
  }
   if(product_type){
      array_values += '&producttype='+product_type;
   }     
        if(coll_value){
          var urll = '/collections/'+coll_value+'/?colour='+ array_values;
          console.log(urll);
    //filtersort(urll);
          window.location.href = urll;
        }
  
  
      }
  
    
  function filtersort(urll) {
    $.ajax({
    url: urll,
    type:'GET',
    success: function(data) {
      var sortdata = $(data).find('.load_collection_data_c').html();
      $('.load_collection_data_c').html(sortdata);
      //console.log(sortdata);
    }
    });
  } 
  
  $('.collection-color-checkbox').click(function(){
      $(this).toggleClass('color_swatch_active');
     var name=$(this).attr('dataname');
     var datahandle=$(this).attr('datahandle');
     if ($(this).hasClass("color_swatch_active")) {
       var ss="product_colour";
    seleteditem_filter(name,datahandle,ss);
     }
    else{
      removedditem_filter(name,datahandle);
    }
  });
  
  $('.size_collection_filter .radio.radio_nocss input').click(function(){  
  var name = $(this+':checked').val(); 
  var datahandle = $(this+':checked').attr(datahandle);  
  var ss="product_type";
    seleteditem_filter(name,datahandle,ss);
  }); 
  
    $("body").delegate("#clear_allfilter", "click", function(e){ 
    var url = $(this).attr('data-href');
    window.location.href = url;
  });   
  $("body").delegate("div#filterModalBar_c span.selected_deleted_item", "click", function(e){ 
    var dele = $(this).parents('li').attr('deleteitem');
    var datasel = $(this).parents('li').attr('datasel');
    var name = '';
      if(datasel == 'product_type'){
          checkboxhide_producttype(dele);
      }else{
        filterhide_colour(dele);
      }
    removedditem_filter(name,dele);
  });
  $("body").delegate(".Selected_filter.filter_footer button.withouthover.btn-standared", "click", function(e){ 
    var lcount = $('.selected-items ul').find('li').length;
  console.log(lcount+'kkk');
  //if(lcount > 0){
    filtercolour_tag();
  //}
  });
    
  function seleteditem_filter(name,datahandle,ss){
    $('.Selected_filter').show();
  $('.Selected_filter .selected-items ul').append('<li deleteitem="'+datahandle+'" datasel="'+ss+'">'+name+' <span class="selected_deleted_item" ><svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg"><g id="Group 677"><path id="Vector 3" d="M1 1L11 11" stroke="#2C2C2A"></path><path id="Vector 4" d="M11 1L1 11" stroke="#2C2C2A"></path></g></svg></span></li>');
  }  
  
  function checkboxhide_producttype(dele){
    $('label.checkbox.control-checkbox').find('[datahandle="'+dele+'"]').click();
  }  
    function filterhide_colour(dele){
    $('.colors_filter_collection').find('[datahandle="'+dele+'"]').click();
  }  
  
  function removedditem_filter(name,datahandle){
    $('.Selected_filter .selected-items ul li[deleteitem="'+datahandle+'"]').remove();
  }  
    
  });